import { useParams, useHistory, NavLink, Link } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import useHttp from "../../hooks/use-http";
import { endPoints } from "../../config/end-points";
import ReactPaginate from "react-paginate";
import cuteAlert, { cuteToast } from "../UI/cute";
import { useSelector, useDispatch } from "react-redux";
import { authActions } from "../../store/auth";
import { AiFillLock } from "react-icons/ai";
import { access_specifier } from "../../config/app.config";

import NotFound from "../shared/404";

const Users = () => {
  const user_roles = useSelector((state) => state.auth.roles);

  const { page_no } = useParams();
  const { sendRequest } = useHttp();

  const [users, setUsers] = useState([]);
  const [count, setCount] = useState();
  const [search, setSearch] = useState();
  const [load, setIsload] = useState(1);
  const ref = useRef();
  const history = useHistory();
  const dispatch = useDispatch();

  var options = {
    weekday: "short", //long
    year: "numeric",
    month: "short", //long
    day: "numeric",
  };

  const subdomain_name = useSelector(state => state.auth.product.subdomain_name)

  useEffect(() => {
    document.title = `${subdomain_name} | Users`;
  },[subdomain_name]);

  useEffect(() => {
    const responseData = (response) => {
      console.log(response);
      if(response.status === 200){
        if (response.totalPages > 0 && response.content.length === 0) {
          history.push("/users");
        }

        setUsers(response.content);
        setCount(response.totalPages);
        dispatch(authActions.setLoaderStatus({ status: false }));
      }else{
        console.log(response);
        dispatch(authActions.setLoaderStatus({ status: false }));
        history.push("/404");
      }
    };

    const page = page_no ? page_no : "";
    const url =
      endPoints.getAllusers + "/" + page + (search ? "?search=" + search : "");
    sendRequest({ url: url, method: "GET" }, responseData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page_no, search, load]);

  const handlePageChange = ({ selected }) => {
    if (selected === 0) {
      history.push("/users");
    } else {
      history.push("/users/" + selected);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSearch(ref.current.value);
  };

  //Delete the users

  const responseDelete = (response) => {
    cuteToast({
      type: "error",
      message: "",
      timer: 5000,
      title: "User deleted",
    });

    setIsload(parseInt(load) + 1);
    // history.push(location.pathname);
  };

  const handleDeleteUser = (e, user_id) => {
    e.preventDefault();

    cuteAlert({
      type: "question",
      title: "Are you sure",
      message: "You cant roll back after delete",
      confirmText: "Delete",
      cancelText: "Cancel",
      img: "https://engageleads-gallery.s3.us-west-2.amazonaws.com/compareshopvideo/icons/question.svg",
    }).then((e) => {
      if (e === "confirm") {
        sendRequest(
          { url: endPoints.deleteUser, method: "POST", body: { user_id } },
          responseDelete
        );
      } else {
        cuteToast({
          type: "success",
          message: "",
          timer: 5000,
          title: "user not deleted!",
        });
      }
    });
  };

  const handleAvtivateUser = (e, user_id) => {
    e.preventDefault();

    sendRequest(
      { url: endPoints.activateUser, method: "POST", body: { user_id } },
      (response) => {
        console.log(response);
        setIsload(parseInt(load) + 1);
        cuteToast({
          type: "success",
          message: "User Access Granted!",
          timer: 5000,
          title: "Activated",
        });
      }
    );
  };

  const handleIpRestrict = (e, user_id) => {
    e.preventDefault();

    cuteAlert({
      type: "question",
      title: "Are you sure",
      message: "You want to unlock user from ip Restriction",
      confirmText: "Yes,Unlock it",
      cancelText: "No Cancel !",
      img: "https://engageleads-gallery.s3.us-west-2.amazonaws.com/compareshopvideo/icons/question.svg",
    }).then((e) => {
      if (e === "confirm") {
        sendRequest(
          { url: endPoints.restrictUser, method: "POST", body: { user_id } },
          (response) => {
            if (response) {
              cuteToast({
                type: "success",
                message: "User Access Granted to login into "+{subdomain_name}+" app!",
                timer: 5000,
                title: "Removed Restriction",
              });
            }
            setIsload(parseInt(load) + 1);
          }
        );
      } else {
        cuteToast({
          type: "success",
          message: "",
          timer: 5000,
          title: "User Restricted!",
        });
      }
    });
  }

  const getAccess = (access) => {
    if (access.includes("91")) {
      return "JV";
    } else if (access.includes("9S")) {
      return "Template Management";
    } else if (access.includes("9") || access.includes("9A")) {
      return "Admin";
    } else if(access.split(",").sort().reverse().some(value => Object.keys(access_specifier).includes(value))){
      const accessName =  Object.keys(access_specifier).sort().reverse().map((item) => access.includes(item) ? access_specifier[item] : null);
      return accessName.filter(Boolean)[0];
    } else if (access.includes("8") || access.includes("81")) {
      return "Bundle";
    } else if (access.includes("4")) {
        return "DFY";
    } else if (access.includes("2")) {
        return "Pro";
    } else if (access.includes("1")) {
      return "Core";
    }
  };
  return (
    <>
      {user_roles.role_id === 1 ? (
        <NotFound />
      ) : (
        <section className="mid_wrap">
          <div className="container">
            <div className="row align-items-center mb-4 pb-4">
              <div className="col-6">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                      <a href="#0">Dashboard</a>
                    </li>
                    <li className="breadcrumb-item active">User</li>
                  </ol>
                </nav>
              </div>

              <div className="col-6 d-flex">
                <NavLink className="btn ms-auto" to="/create-user">
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/plus.png`}
                    alt="img"
                  />{" "}
                  Create New
                </NavLink>
              </div>
            </div>
            <div className="row mb-5">
              <div className=" col-xl-5 col-lg-5 col-md-12 m-auto">
                <div className="search_form2 position-relative">
                  <form onSubmit={handleSubmit}>
                    <input
                      name=""
                      type="text"
                      className=" form-control"
                      placeholder="Enter your email"
                      ref={ref}
                    />
                    <input
                      name=""
                      type="submit"
                      value="Search"
                      className="btn"
                    />
                  </form>
                </div>
              </div>
            </div>
            <div className="p_bx ovr_auto mb-5">
              <table
                className="table usertable"
                width="100%"
                cellSpacing="0"
                cellPadding="0"
                border="0"
              >
                <thead>
                  <tr>
                    <th>User name</th>
                    <th>Email address</th>
                    <th>Status</th>
                    <th>Type</th>
                    <th>Created At</th>

                    <th>Last login</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {users.length > 0 &&
                    users.map((user) => {
                      return (
                        <tr valign="middle" key={user.id}>
                          <td>{`${user.first_name} ${user.last_name}`}</td>
                          <td>{user.email}</td>
                          <td
                            className={`${
                              user.active === 1 ? "text-success" : "text-danger"
                            }`}
                          >
                            {user.active === 1 ? "A" : "IA"}
                          </td>
                          <td style={{width:"20%"}}>{getAccess(user.access)}</td>
                          <td>
                            {new Date(user.createdAt).toLocaleDateString(
                              "en-US",
                              options
                            )}
                          </td>
                          <td>
                            {new Date(user.updatedAt).toLocaleDateString(
                              "en-US",
                              options
                            )}
                          </td>
                          <td>
                            <div className=" link_vd ">
                              <ul>
                                <li>
                                  <Link to={`/users/edit/${user.id}`}>
                                    <i>
                                      <img
                                        src={`${process.env.PUBLIC_URL}/assets/images/edit.png`}
                                        alt="img"
                                      />
                                      <img
                                        src={`${process.env.PUBLIC_URL}/assets/images/edit_hv.png`}
                                        alt="img"
                                      />
                                    </i>
                                  </Link>
                                </li>
                                {user.active === 1 && (
                                  <li>
                                    <a
                                      href="#0"
                                      onClick={(e) =>
                                        handleDeleteUser(e, user.id)
                                      }
                                    >
                                      <i>
                                        <img
                                          src={`${process.env.PUBLIC_URL}/assets/images/delete.png`}
                                          alt="img"
                                        />
                                        <img
                                          src={`${process.env.PUBLIC_URL}/assets/images/delete_hv.png`}
                                          alt="img"
                                        />
                                      </i>
                                    </a>
                                  </li>
                                )}

                                {user.active !== 1 && (
                                  <li>
                                    <a
                                      href="#0"
                                      onClick={(e) =>
                                        handleAvtivateUser(e, user.id)
                                      }
                                    >
                                      <i>
                                        <img
                                          src={`${process.env.PUBLIC_URL}/assets/images/refresh.png`}
                                          alt="img"
                                        />
                                        <img
                                          src={`${process.env.PUBLIC_URL}/assets/images/refresh_hv.png`}
                                          alt="img"
                                        />
                                      </i>
                                    </a>
                                  </li>
                                )}

                                <li>  
                                  <a href="#0" onClick={(e) => handleIpRestrict(e, user.id)} className="actionBtn">
                                    <AiFillLock 
                                      size={20} 
                                      color={user.restrict_user ? "grey":"red"}
                                      onMouseOver={({target})=>target.style.color="white"}
                                      onMouseOut={({target})=>target.style.color= user.restrict_user ? "grey":"red"}
                                    />
                                  </a>
                                </li>

                              </ul>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  {users.length === 0 && (
                    <tr>
                      <td colSpan={5}>No Record Found</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            {count > 0 && (
              <nav aria-label="...">
                <ReactPaginate
                  previousLabel={"<<"}
                  nextLabel={">>"}
                  breakLabel="..."
                  breakLinkClassName={"page-link"}
                  pageCount={count}
                  onPageChange={handlePageChange}
                  containerClassName={"pagination justify-content-center"}
                  pageClassName={"page-item"}
                  pageLinkClassName={"page-link"}
                  activeClassName={"active"}
                  previousClassName={"page-item"}
                  nextClassName={"page-item"}
                  previousLinkClassName={"page-link"}
                  nextLinkClassName={"page-link"}
                  disabledClassName={"d-none"}
                  initialPage={page_no ? parseInt(page_no) : ""}
                />
              </nav>
            )}
          </div>
        </section>
      )}
    </>
  );
};

export default Users;
